export const OPEN_ALERT_PROFILE = "OPEN_ALERT_PROFILE";
export const CLOSE_ALERT_PROFILE = "CLOSE_ALERT_PROFILE";
